import { Inject, Injectable } from '@angular/core';
import { IStateService } from 'angular-ui-router';

@Injectable()
export class NotificationMessageParser {
  constructor(@Inject('$state') private $state: IStateService) {}

  /**
   * Notification message from DB may contain anchor tag w/ href (pointing to targeted feature)
   * If so, we need to dynamically create the url with the proper dbn
   *
   * IMPORTANT!: For this to work correctly, the message href should be wrapped in { }
   * Also note the leading slash ( before credit-gaps/next-term-planning ) in the example below
   *
   * Example message:
   * `
   *   New Feature!
   *   <a href='{/credit-gaps/next-term-planning}'>See how many students</a>
   *   are planned for each course in the next term.
   * `
   * (JJ)
   */
  parseMessage(notificationMsg: string): string {
    const base = this.$state.href('main.school');
    const msgUrl = notificationMsg
      .split('{')
      .pop()
      .split('}')
      .shift();

    if (!msgUrl) return notificationMsg;

    const dynamicUrl = `${base}${msgUrl}`;
    notificationMsg = notificationMsg.replace(/{.*}/, dynamicUrl);
    return notificationMsg;
  }
}
